// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"45babfd7","456":"ccdb6458","656":"fb572dc7","756":"4e4fda41","787":"934c349d","968":"7e9bf593"}[chunkId] + ".chunk.js";
};